// extracted by mini-css-extract-plugin
export var orderDetails = "_ve-2";
export var orderImage = "_ve-1";
export var orderMeta = "_ve-3";
export var orderSummary = "_ve-0";
export var rightArrow = "_ve-4";